import Flex from '@Components/Bases/Flex';
import { useDisclosure } from '@hooks/useDisclosure';
import { Add } from '@mui/icons-material';
import { Alert, Box, Button, InputLabel, Typography } from '@mui/material';
import { CompleteSectionFormValues } from '@Utils/Types/FormValuesTypes';
import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { IOtherDetailFormValues } from '../../EsgGreenhouseFormProvider/types';
import { useGreenhouseGoalTerm } from '../GreenhouseGoalTermProvider/GreenhouseGoalTermProvider';
import ModalOtherGreenhouseGas from './ModalOtherGreenhouseGas/ModalOtherGreenhouseGas';
import OtherGreenhouseGasRemark, {
  GH_GAS_REMARK_ID,
} from './OtherGreenhouseGasRemark';
import OtherGreenhouseTable from './OtherGreenhouseTable';

const OtherGreenhouseGas = () => {
  const { ghGasScope } = useGreenhouseGoalTerm();
  const [opened, { open, close }] = useDisclosure();

  const [otherDetails, completedSection] = useWatch({
    name: [
      'greenhouseGoalTerm.other.details',
      'greenhouseGoalTerm.completedSection',
    ],
  }) as [IOtherDetailFormValues[] | undefined, CompleteSectionFormValues];

  const availableScopes = useMemo(() => {
    const usedScopeIds = new Set(otherDetails?.map((detail) => detail.scopeId));
    return ghGasScope?.filter((scope) => !usedScopeIds.has(scope.id));
  }, [otherDetails, ghGasScope]);

  const { isCompletedTh, isCompletedEn } = completedSection ?? {};

  return (
    <Box width={'100%'} mt={2}>
      <Flex gap={1} alignItems={'center'}>
        <Typography fontWeight={'bold'}>
          การตั้งเป้าหมายการลดก๊าซเรือนกระจกอื่น ๆ
        </Typography>
        <OtherGreenhouseGasRemark />
      </Flex>

      <Alert severity="info" sx={{ mt: 2 }}>
        คำชี้แจง :
        กรุณาระบุรายละเอียดการตั้งเป้าหมายการลดก๊าซเรือนกระจกรูปแบบอื่น
        ที่ไม่ใช่การปล่อยก๊าซเรือนกระจกสุทธิเป็นศูนย์หรือความเป็นกลางทางคาร์บอน
        (ถ้ามี)
      </Alert>
      <Flex justifyContent={'space-between'} alignItems={'center'} my={2}>
        <InputLabel required sx={{ fontWeight: 'bold' }}>
          รายละเอียดการตั้งเป้าหมายการลดก๊าซเรือนกระจกอื่น ๆ
        </InputLabel>
        <Button
          color={'inherit'}
          startIcon={<Add />}
          onClick={open}
          disabled={
            isCompletedTh || isCompletedEn || availableScopes?.length === 0
          }
        >
          เพิ่มข้อมูล
        </Button>
      </Flex>
      <OtherGreenhouseTable />
      <Box id={GH_GAS_REMARK_ID} />
      <ModalOtherGreenhouseGas open={opened} mode={'create'} close={close} />
    </Box>
  );
};

export default OtherGreenhouseGas;
